import styled, { css } from 'styled-components'

import * as ds from '@bob/design-system'

import { NewsletterForm } from '@bob/newsletter-form'

type MainSectionProps = {
  iframe?: string
}

export function MainSection({ iframe }: MainSectionProps) {
  return (
    <Main>
      <MainColumnMobile>
        <ds.styles.heading.Title1>
          La <Brush $color="yellow">newsletter</Brush> qui vous aide à mieux <Brush $color="green">consommer</Brush>
        </ds.styles.heading.Title1>
        <ds.styles.copy.Text1>
          Bienvenue ! <strong>Chaque vendredi</strong>, cette infolettre vous accompagne dans le vaste chemin d’une
          consommation plus durable, plus respectueuse des humains et de la planète.
        </ds.styles.copy.Text1>
        <ds.styles.copy.Text1>
          Comment ? À travers des conseils pratiques, des portraits de créatrices et créateurs engagés, des nouveautés à
          découvrir, une revue de presse <strong>et même des petites surprises…</strong>
        </ds.styles.copy.Text1>
      </MainColumnMobile>
      <MainColumn>
        <ds.styles.heading.Title2>
          La <Brush $color="yellow">newsletter</Brush> qui vous aide à mieux <Brush $color="green">consommer</Brush>
        </ds.styles.heading.Title2>
        <ds.styles.copy.Text5>
          Bienvenue ! <strong>Chaque vendredi</strong>, cette infolettre vous accompagne dans le vaste chemin d’une
          consommation plus durable, plus respectueuse des humains et de la planète.
        </ds.styles.copy.Text5>
        <ds.styles.copy.Text5>
          Comment ? À travers des conseils pratiques, des portraits de créatrices et créateurs engagés, des nouveautés à
          découvrir, une revue de presse <strong>et même des petites surprises…</strong>
        </ds.styles.copy.Text5>
      </MainColumn>
      <Newsletter>
        <NewsletterBody>
          <ds.styles.heading.Title3>Inscrivez-vous et bénéficiez de -10% sur Ulule Boutique</ds.styles.heading.Title3>
          <NewsletterForm />
          <ds.styles.copy.Text1>
            Bien ou Bien ne vendra pas votre adresse et vous pourrez arrêter votre abonnement quand vous le désirez.{' '}
            <strong>
              Aussi, vous recevrez -10% sur Ulule Boutique et notre e-book exclusif à l&apos;inscription&nbsp;!
            </strong>
          </ds.styles.copy.Text1>
        </NewsletterBody>
        <ds.stickers.others.Newsletter />
      </Newsletter>
      <IframeSizeLimiter>
        <IframeWrapper>
          <PhoneSvg width="360" height="682" version="1.1" viewBox="0 0 360 682" xmlns="http://www.w3.org/2000/svg">
            <path
              d="m272.3 2.4258c-16.226 0.1639-32.426 1.5439-48.602 2.2534-8.2774 0.37385-16.698 0.20473-25.042 0.24271-41.82 0.0084455-83.641-0.017027-125.46 0.012977-11.107 0.089807-22.327 0.37279-33.193 2.8956-7.7636 1.7765-15.35 5.002-21.349 10.339-6.2199 5.4741-10.165 13.136-12.218 21.08-1.2481 4.612-1.7404 9.3773-2.3784 14.1-2.107 17.901-1.8675 35.975-1.2569 53.958 0.66557 18.744 1.8781 37.437 1.7784 56.184-0.00113 138.93 0.00731 277.86-0.00438 416.79-0.00774 4.778-0.049946 9.5794-0.27115 14.304-0.54205 13.923-1.5219 27.964 0.52256 41.816 1.2463 8.4351 3.7779 16.88 8.7205 23.921 3.5712 5.0385 8.3406 9.2255 13.769 12.163 8.2534 4.3892 17.642 6.0015 26.869 6.7094 14.033 1.047 28.09-0.16815 42.12-0.63997 6.1232-0.19622 12.402-0.0948 18.586-0.11719 38.217 7e-3 76.433-5e-3 114.65 0.0245 18.202 0.1742 36.415 1.5773 54.649 1.0037 9.901-0.34633 19.853-1.2992 29.437-3.9139 5.3008-1.4928 10.515-3.4571 15.261-6.2742 4.0837-2.4307 7.9014-5.3526 11.058-8.9225 2.4469-2.6235 4.5537-5.55 6.2766-8.6961 4.7565-8.3546 6.9348-17.909 7.9357-27.396 0.72984-7.9404 0.84592-15.92 1.2314-23.882 0.77707-19.98 1.3025-39.968 1.6543-59.96 1.0168-59.873 0.3472-119.76-0.40924-179.63-0.31612-26.74-0.67631-53.481-0.96443-80.221-3e-3 -3.2348-0.1076-6.4714 0.0254-9.7048 0.0318-0.48484 0.0502-1.0625 0.0965-1.5926 0.0801-1.0974 0.18978-2.1164 0.32929-3.1301 0.46313-2.3059-0.44434-4.9551-0.41803-8.0176 0.0263-3.0624 1.1134-3.8552 0.86481-5.1287-0.52469-2.514-0.8265-5.072-0.93897-7.637-0.0327-0.76386-0.0598-1.8244-0.0575-2.707 0.0644-10.826 0.27098-21.652 0.48309-32.476 0.97982-49.68 2.6234-99.447-0.66745-149.08-0.27234-3.7653-0.46477-7.5285-0.8451-11.261-0.29192-2.3998-0.49546-4.8153-1.1012-7.1634-0.34546-1.828-0.79806-3.6295-1.4389-5.3773-0.67446-2.443-1.837-4.7048-2.8847-6.9988-1.1881-1.8881-2.1984-3.8943-3.6576-5.597-1.1561-1.6432-2.5498-3.0843-3.9574-4.5104-1.3253-1.398-2.9062-2.5258-4.3615-3.7813-1.9806-1.3135-3.8945-2.7333-6.0326-3.7883-2.0674-1.2193-4.2971-2.1261-6.496-3.0754-4.942-1.9282-10.061-3.3826-15.271-4.3736-12.182-2.4156-24.653-2.8514-37.04-2.7471zm-102.51 51.699c10.123 0.03058 20.249 0.03223 30.369 0.31055 16.899 0.55529 33.898 1.1897 50.836 1.7482 15.379 0.50662 30.752 1.1774 46.123 1.8677 5.0011 0.27421 10.019 0.30989 15.006 0.79611 4.1388 0.40212 8.3751 1.577 11.565 4.367 3.1491 2.7494 5.2787 6.5333 6.5312 10.487 1.8748 6.1449 1.1897 12.636 1.0755 18.953-0.0925 5.4007 0.40136 10.789 0.54571 16.185 0.3493 8.3228 0.0983 16.753 0.0518 25.119-0.23209 23.266-0.50553 46.531-0.62775 69.797-0.24608 37.045-0.51322 74.091-0.71648 111.14-0.0938 42.505 0.50675 85.006 0.89623 127.51 0.16213 15.193 0.30935 30.385 0.3567 45.579 0.024 10.859 0.19719 21.719 0.046 32.578-0.29932 32.162-0.56539 64.324-0.90727 96.485-0.12204 6.7594-0.44626 13.782-3.4359 19.979-2.4541 5.179-7.0858 9.0535-12.259 11.355-4.6142 2.084-9.6068 3.1948-14.608 3.8539-0.81301 0.0985-1.9154 0.23024-2.8398 0.31641-10.034 0.96798-20.118 0.30727-30.173 0.20781-22.808-0.35833-45.617-0.66227-68.426-0.99129-14.885-0.0494-29.772-7e-3 -44.657-0.0212-12.357 0.0135-24.714-0.0237-37.07 0.0706-17.354 0.16347-34.706-0.21861-52.05-0.75136-5.3294-0.16444-10.663-0.27882-16.005-0.54009-3.9691-0.24511-8.1787-1.606-10.688-4.8667-0.97246-1.3403-1.7885-2.7874-2.6955-4.1722-0.26519 0.36149-0.38405 1.5526-0.85787 0.75947-3.0353-3.1672-3.9771-7.6966-4.2585-11.934-0.3585-6.1822-0.29916-12.38-0.45151-18.569-0.80724-49.132-1.7634-98.262-2.2676-147.4-0.11836-19.238-0.33202-38.476-0.31022-57.715-0.01055-11.511 0.17191-23.022 0.25015-34.533 0.87453-96.341 1.73-192.68 2.6318-289.02 0.02972-1.3526 0.0781-2.4818 0.17719-3.8337 0.4214-5.3101 1.5002-10.853 4.8092-15.177 1.9908-2.5251 4.8157-4.3464 7.8958-5.2033 7.193-2.3423 14.808-2.909 22.319-3.2511 8.0195-0.29966 16.204-0.0696 24.3-0.21282 26.502-0.64212 53.008-1.2575 79.52-1.2664z"
              fill={ds.color.SAND_1}
            />
            <path
              d="m275.54 0.0058594c-12.806 0.009194-25.614 0.81649-38.393 1.5625-8.532 0.47632-17.024 0.99549-25.514 0.93945h-25.725-102.69c-8.4906 0-17.01-0.069818-25.543 0.47656-8.5186 0.56038-17.122 1.6801-25.346 4.5801-4.0839 1.471-8.0557 3.433-11.648 5.9687-3.6067 2.5217-6.7785 5.6737-9.3047 9.2461-5.1083 7.1449-7.6749 15.691-8.7695 23.9-2.5682 16.419-2.794 32.74-2.5273 48.697 0.32278 15.957 1.2639 31.591 1.7832 46.861 0.28068 7.65 0.37768 15.159 0.34961 22.668v22.234 42.785 77.654 157.33 42.799 49.594c-0.02807 9.597 0.057582 19.921-0.054688 30.652-0.25262 10.745-1.1798 22.193-0.87109 34.311 0.15437 6.053 0.65954 12.286 1.8945 18.576 1.2771 6.276 3.34 12.666 6.8906 18.508 1.7823 2.9 3.9293 5.645 6.4414 8.082 2.498 2.396 5.2488 4.6083 8.3223 6.4023 6.1468 3.586 13.081 5.5619 20.098 6.7109 14.09 2.242 28.601 1.4298 43.225 0.75781 3.6629-0.168 7.3251-0.3372 11.002-0.4082 3.6487-0.07 7.4092-0.02702 11.156-0.04102h22.793c30.706 0 62.662 3e-4 95.432 0.0293 16.293 0.112 32.881 1.3008 49.75 1.1328 8.435-0.084 16.952-0.51795 25.457-1.877 8.49-1.303 16.996-3.6978 24.812-7.8438 3.845-2.186 7.5494-4.695 10.777-7.791 3.158-3.124 6.1199-6.5425 8.2949-10.438 4.659-7.635 7.0723-16.306 8.3633-24.922 0.688-4.315 0.94006-8.701 1.1641-13.002l0.53516-12.846c0.392-8.559 0.61744-17.133 0.89844-25.707 1.038-34.282 1.3887-68.522 1.3887-102.27s-0.33714-67.008-0.74414-99.342c-0.393-31.648-0.77305-62.384-1.123-91.818-0.043-4.441-0.08333-8.0836-0.11133-9.8906-0.084-6.711-0.8714-10.522-2.3164-16.125-1.348 5.617-2.0765 9.4433-2.0625 16.154 0 1.821 0.04231 5.4614 0.07031 9.9024 0.365 29.434 0.74405 60.172 1.123 91.82 0.407 32.334 0.74218 65.564 0.74218 99.285s-0.35067 67.919-1.3887 102.13c-0.281 8.56-0.50544 17.118-0.89844 25.664l-0.5332 12.82c-0.239 4.245-0.47805 8.4041-1.123 12.537-1.235 8.223-3.5231 16.349-7.7891 23.326-1.993 3.572-4.6858 6.654-7.5488 9.498-2.919 2.816-6.3159 5.1002-9.8379 7.1172-7.214 3.825-15.228 6.1082-23.41 7.3691-8.182 1.317-16.503 1.7523-24.811 1.8223-16.63 0.168-33.19-1.0237-49.68-1.1367-32.784 0-64.754 3.3e-4 -95.461-0.01367h-22.791c-3.761 0-7.4669-0.02703-11.256 0.04297-3.7471 0.085-7.4504 0.25192-11.113 0.41992-14.623 0.686-28.91 1.4428-42.312-0.70117-6.6662-1.078-13.095-2.9561-18.582-6.1641-2.7367-1.583-5.221-3.5842-7.4805-5.7422-2.2314-2.171-4.154-4.6105-5.7539-7.2305-3.1998-5.267-5.1212-11.165-6.3281-17.092-1.1648-5.954-1.6562-11.936-1.8105-17.834-0.30875-11.796 0.61653-23.17 0.86914-34.084 0.11227-10.941 0.028581-21.127 0.056641-30.752v-49.594-42.799-157.33-77.641-42.785-22.232c0.02807-7.495-0.070882-15.159-0.35156-22.822-0.51925-15.354-1.4588-30.962-1.7676-46.807-0.26664-15.817-0.028216-31.941 2.4277-47.912 0.50523-4.0487 1.4026-7.8313 2.6797-11.586 1.2911-3.7125 3.0468-7.2574 5.3203-10.438 4.4909-6.4304 11.311-10.941 18.861-13.631 7.6065-2.6899 15.845-3.7974 24.139-4.3437 8.3222-0.53236 16.757-0.44888 25.262-0.46289h102.69 25.725c8.644 0.05603 17.248-0.46084 25.781-0.95117 17.051-1.0087 33.99-2.0879 50.705-1.2754 8.35 0.40628 16.615 1.3731 24.6 3.2363 4 0.88261 7.8588 2.186 11.635 3.6289l2.75 1.2324 1.377 0.61719 1.3047 0.72852 2.625 1.4414 2.4551 1.668 1.2344 0.82617 1.1387 0.95312 2.2578 1.8906 2.0352 2.1152c0.337 0.3502 0.68872 0.68625 1.0117 1.0645l0.89648 1.1641 1.7832 2.3262 1.502 2.5059 0.75781 1.248 0.60351 1.3301 1.207 2.6621c0.379 0.8966 0.63045 1.8488 0.93945 2.7734 0.281 0.9386 0.67347 1.836 0.85547 2.8027l0.61914 2.8711c0.21 0.9526 0.43358 1.9061 0.51758 2.8867 0.197 1.9754 0.51981 3.853 0.63281 5.8984 0.14 2.0174 0.29455 4.0337 0.43555 6.0371 2.231 32.166 2.3422 63.562 1.9492 93.584-0.19601 15.018-0.51913 29.7-0.82813 44.004-0.14 7.159-0.29455 14.207-0.43555 21.156-0.098 6.052-0.18129 12.019-0.27929 17.875 0 0.995-0.01335 1.9184-0.02735 2.7734 0 1.695-0.02929 3.0558-0.02929 3.9668-0.043 6.724 0.72946 10.548 2.1055 16.152l0.02735 0.01367c1.431-5.618 2.1754-9.415 2.2734-16.125 0-0.911 0.02864-2.2698 0.05664-3.9648 0.449-24.489 0.98326-53.699 1.5723-85.809 0.393-30.078 0.29483-61.601-1.9512-93.949-0.14-2.0174-0.29455-4.049-0.43555-6.0664-0.112-2.0033-0.4482-4.1454-0.6582-6.2188-0.084-1.0507-0.32383-2.0746-0.54883-3.1113l-0.67187-3.1094c-0.211-1.0367-0.63341-2.032-0.94141-3.0547-0.351-1.0087-0.63206-2.0445-1.0391-3.0391l-1.332-2.9434-0.67383-1.4707-0.82813-1.3867-1.6836-2.7871c-0.645-0.8686-1.3205-1.7232-1.9805-2.5918l-0.99609-1.2891c-0.351-0.4062-0.74405-0.78544-1.123-1.1777l-2.2715-2.3398-2.498-2.0859-1.25-1.0371-1.3477-0.91016-2.6934-1.8223-2.8359-1.5684-1.418-0.78516-1.4727-0.67188-2.9473-1.332c-4.014-1.5551-8.0973-2.9133-12.279-3.8379-8.35-1.9613-16.869-2.9274-25.387-3.3477-4.2665-0.20664-8.5361-0.29213-12.805-0.28906zm-68.203 23.895c-0.14627 0.001967-0.28472 0.006671-0.41797 0.013671-0.561 0.042001-0.94194 0.084526-1.4609 0.14063-0.997 0.1401-2.0473 0.34944-3.0723 0.83984-0.912 0.4623-1.5451 0.85453-2.2461 1.457-0.786 0.7004-1.137 1.4023-1.334 1.8086-0.35 0.7705-0.47753 1.4139-0.51953 1.9883-0.042 0.6164 0.01525 1.1632 0.15625 1.6816 0.28 1.0227 0.84229 1.8498 1.5293 2.8164 1.404-2.0174 2.1177-3.181 2.7637-4.582 0.084-0.1681 0.19754-0.33582 0.31054-0.41992 0.196-0.1821 0.75738-0.54706 1.2344-0.78516 0.379-0.1822 1.0106-0.34927 1.7266-0.44727 0.337-0.0421 0.84106-0.099281 1.1641-0.11328 0.351-0.028 0.60249 0.001297 0.77149 0.029297 0.182 0.042 0.26621 0.069641 0.44921 0.18164 0.196 0.1121 0.39385 0.28036 0.58985 0.47656 0.393 0.3782 0.75676 0.85347 1.0098 1.2598 0.28 0.4343 0.42154 0.72892 0.51954 0.95312 0.098 0.2241 0.12695 0.34961 0.12695 0.34961s0.19595 0.47666 0.25195 1.4434v0.39258 0.12695c0.21 0-0.46311 0.013672 0.46289 0.013672h-0.30859c-0.253 0-0.1123 0.013343-0.1543 0.027343-0.014 0.1261-0.08397 0.34969-0.16797 0.58789-0.196 0.4903-0.5344 1.0514-0.9414 1.5137s-0.884 0.82755-1.375 1.0938c-0.492 0.2241-1.0106 0.33528-1.5156 0.36328-1.01 0.0701-1.9921-0.35013-2.4551-0.49023-0.912-0.3643-1.4181-0.4761-2.0781-0.6582-0.182-0.07-0.29456-0.056525-0.47656-0.14062-0.183-0.084-0.37885-0.19649-0.58985-0.30859-0.39271-0.24335-0.83871-0.49965-1.3105-0.83203-0.1773 0.56685-0.26127 1.1206-0.30274 1.6602-0.015 0.2662-0.01566 0.54607 0.02734 0.82617 0.028 0.2942 0.18326 0.65796 0.28126 0.91016 0.477 1.1347 1.5713 2.0735 2.8203 2.5918 0.73 0.2382 2.1609 0.92557 4.2949 0.85547 1.052-0.042 2.2169-0.2942 3.2969-0.8125 1.067-0.5324 2.022-1.3036 2.752-2.1582 0.744-0.8546 1.3043-1.7927 1.6973-2.7734 0.183-0.4903 0.35155-0.99526 0.43555-1.5977 0.085-0.7845 0.04134-1.0234 0.02734-1.4297-0.042-0.7425-0.15362-1.3857-0.26562-1.834-0.113-0.4483-0.19727-0.70117-0.19727-0.70117s-0.06995-0.25125-0.25195-0.68555c-0.169-0.4343-0.47714-1.0382-0.86914-1.6406-0.407-0.6304-0.92725-1.3301-1.6562-2.0586-0.365-0.3642-0.79999-0.71458-1.334-1.0508-0.533-0.3503-1.2642-0.64548-1.9512-0.77148-0.516-0.094575-1.0085-0.11723-1.4473-0.11133zm-7.3574 10.781c0.00225-0.007198 0.00357-0.014283 0.00586-0.021485l-0.05665-0.013672c0.01724 0.012296 0.03362 0.023065 0.05079 0.035157zm-43.008-4.0625c-1.7296 0-3.1509 0.005531-3.8594 0.019531-2.611 0.042-4.0991 0.82686-6.2461 2.2559l-0.01367 0.013672c2.203 1.359 3.6764 2.1012 6.2734 2.1152 2.821 0 16.926 0.070312 16.926 0.070312s14.146 0.1823 16.967 0.1543c2.61-0.028 4.0965-0.77088 6.2715-2.1719-2.175-1.4009-3.6481-2.1571-6.2441-2.1992-2.821-0.028-16.939-0.1543-16.939-0.1543s-3.5368-0.041984-7.4238-0.083984c-1.944-0.014-3.9813-0.019531-5.7109-0.019531zm-5.4043 21.596c-12.336 0.1261-25.035 0.34871-38.059 0.62891-6.512 0.1541-13.11 0.30879-19.775 0.46289-6.6521 0.2242-13.317 0.098625-20.193 0.14062-6.8486 0.0561-13.837 0.26603-20.896 1.3027-3.5225 0.5184-7.0875 1.2883-10.582 2.5352-3.719 1.1768-7.1853 4.0075-9.1641 7.4258-2.049 3.4044-3.0172 7.1728-3.5645 10.857-0.5474 3.6845-0.58952 7.4384-0.60352 10.969-0.0702 7.1589-0.12707 14.388-0.19727 21.645-0.2666 29.056-0.53385 58.826-0.81445 88.947-0.5474 60.241-1.1073 121.84-1.6406 181.75-0.0702 7.481-0.12707 14.948-0.19727 22.373 0 7.425 0.013244 14.821 0.027344 22.191 0.0982 14.71 0.21039 29.28 0.30859 43.625 0.3088 28.706 0.75803 56.599 1.207 83.287 0.4351 25.862 0.857 50.562 1.25 73.734 0.028 1.008 0.042312 1.9458 0.070313 2.8008 0.0562 1.723 0.14084 3.1248 0.21094 4.0488 0.2667 3.447 0.92613 6.2209 2.0488 8.6719 1.1368 2.424 2.8491 4.5664 5.291 6.1074l0.019531-0.04687c1.5014 2.4886 3.6739 4.1819 6.1406 5.2734 1.249 0.546 2.583 0.95242 4.0566 1.2324 1.4595 0.28 3.1002 0.39126 4.7422 0.44726 1.8244 0.056 5.4734 0.18227 9.9082 0.32227 6.1048 0.168 12.281 0.35153 18.512 0.51953 6.8346 0.168 13.738 0.29361 20.713 0.34961 6.975 0.056 14.019 0.05698 21.107-0.04102 7.073 0 14.217-0.01529 21.402-0.02929h54.746c3.705 0.056 7.4099 0.09829 11.129 0.15429 7.438 0.112 14.904 0.21027 22.398 0.32227 14.974 0.238 30.104 0.37817 45.219 0.70117 7.592 0.21 15.309 0.3358 23.07-0.5332 3.873-0.434 7.7601-1.1199 11.578-2.2969 1.908-0.589 3.803-1.2749 5.627-2.1719 1.839-0.868 3.6217-1.905 5.2637-3.166 1.656-1.233 3.2012-2.6754 4.4922-4.3144 1.333-1.625 2.4279-3.4329 3.2559-5.3379 1.698-3.797 2.4683-7.7889 2.8613-11.711 0.379-3.923 0.40722-7.7903 0.44922-11.572l0.11328-11.391c0.14-15.187 0.27992-30.331 0.41992-45.391 0.14-15.061 0.2822-30.037 0.4082-44.887-0.07-14.85-0.15461-29.56-0.22461-44.088-0.295-29.042-0.5758-57.369-0.84179-84.576-0.239-27.206-0.42158-53.292-0.26758-77.879 0.154-24.601 0.30922-47.704 0.44922-68.914 0.154-21.225 0.28057-40.558 0.39257-57.621 0.182-17.064 0.32322-31.871 0.44922-44.018 0.056-6.08 0.1123-11.501 0.1543-16.209 0-4.749-0.13963-8.7562-0.26563-11.992-0.295-6.458-0.44921-9.8906-0.44921-9.8906 0 0 3.2e-4 -0.21089-0.01368-0.61719 0-0.4062-0.04329-1.0077-0.02929-1.8203-0.014-1.6111 0.07159-4.0209 0.18359-7.2852 0.056-3.2502 0.26591-7.4403-0.87109-12.428-0.575-2.4656-1.5859-5.1277-3.0879-7.6074-1.473-2.5077-3.5491-5.1133-6.4961-6.9766-2.905-1.9333-6.4845-2.8707-9.9785-3.291-3.537-0.4343-7.0733-0.4761-10.736-0.6582-7.353-0.3222-15.339-0.67258-23.871-1.0508-17.08-0.7566-36.475-1.3173-57.736-2.0879-10.638-0.3362-21.725-0.88183-33.275-0.92383-11.536-0.1261-23.508-0.1121-35.844 0zm0.07226 4.3145c12.307-0.112 24.236-0.1401 35.744 0 11.508 0.0561 22.595 0.58753 33.205 0.92383 21.233 0.7705 40.571 1.3314 57.65 2.0879 8.547 0.3783 16.517 0.72891 23.885 1.0371 3.691 0.1821 7.2141 0.23671 10.371 0.62891 3.158 0.3923 5.9656 1.1638 8.1406 2.6348 2.217 1.401 3.8444 3.4038 5.1074 5.5332 1.291 2.1435 2.0916 4.2732 2.5976 6.3887 0.982 4.2169 0.82882 8.1128 0.75782 11.293-0.112 3.1942-0.1976 5.7143-0.1836 7.4375 0 0.8546 0.01497 1.513 0.04297 1.9473 0 0.4343 0.01367 0.66016 0.01367 0.66016s0.15455 3.4173 0.43555 9.8613c0.126 3.208 0.25195 7.1729 0.25195 11.838-0.042 4.694-0.09729 10.102-0.15429 16.168-0.126 12.147-0.27989 26.955-0.46289 44.033-0.112 17.077-0.25125 36.41-0.40625 57.635-0.14 21.224-0.29422 44.324-0.44922 68.939-0.154 24.601 0.01295 50.73 0.25195 77.936 0.266 27.207 0.5468 55.534 0.8418 84.576 0.07 14.514 0.14061 29.225 0.22461 44.061-0.14 14.836-0.27925 29.799-0.40625 44.859-0.14 15.06-0.28088 30.188-0.42188 45.361l-0.09766 11.391c-0.04199 3.81-0.07087 7.565-0.42187 11.207-0.365 3.629-1.08 7.2015-2.498 10.354-0.674 1.583-1.586 3.0541-2.666 4.3711-1.053 1.345-2.3158 2.5356-3.7188 3.5586-2.765 2.101-6.0773 3.5717-9.5293 4.6367-3.467 1.065-7.1003 1.7229-10.777 2.1289-7.367 0.827-14.891 0.71586-22.455 0.50586-15.213-0.323-30.299-0.46317-45.316-0.70117-7.508-0.112-14.974-0.21026-22.426-0.32226-3.719-0.056-7.4376-0.0983-11.143-0.1543h-54.789c-7.185 0-14.328 0.01334-21.402 0.02734-7.059 0.084-14.076 0.09897-21.023 0.04297-6.9464-0.056-13.822-0.18161-20.643-0.34961-6.2311-0.168-12.392-0.35153-18.482-0.51953-4.4488-0.126-8.0838-0.23697-9.9082-0.29297-1.7262-0.042-3.0874-0.02961-4.3926-0.09961-1.2911-0.056-2.484-0.13897-3.6348-0.29296-2.2989-0.30766-4.5284-0.73024-7.0371-2.1973l0.019531-0.04492c-1.4174-2.535-1.866-4.7496-2.2168-7.0606-0.3228-2.326-0.53321-4.7913-0.75781-8.0273-0.0561-0.883-0.12749-2.1992-0.18359-3.8672-0.3649-21.813-0.81349-47.857-1.3047-76.465-0.4631-26.688-0.91233-54.566-1.207-83.258-0.098199-14.346-0.21029-28.887-0.30859-43.598 0-7.355-0.013344-14.739-0.027344-22.164 0.0702-7.425 0.12511-14.878 0.19531-22.373 0.5473-59.877 1.0953-121.48 1.6426-181.7 0.2667-30.121 0.54818-59.892 0.80078-88.934 0.0701-7.257 0.12521-14.472 0.19531-21.645 0.0141-3.6284 0.0573-7.0462 0.5625-10.395 0.4772-3.3342 1.3607-6.5568 2.9746-9.2188 0.7719-1.3449 1.7828-2.4794 2.9336-3.418 1.1508-0.9807 2.4417-1.6121 3.9434-2.1445 3.1155-1.1067 6.4138-1.8339 9.7539-2.3242 6.6942-0.9947 13.501-1.2057 20.279-1.2617 6.7504-0.042 13.569 0.069475 20.264-0.14062 6.6664-0.1541 13.263-0.30684 19.76-0.46094 13.01-0.2802 25.698-0.50476 38.006-0.63086z"
              fill={ds.color.GRAY_3}
            />
          </PhoneSvg>
          {iframe ? (
            <Iframe src={iframe} />
          ) : (
            <FakeIframe>
              <ds.Loader />
            </FakeIframe>
          )}
        </IframeWrapper>
      </IframeSizeLimiter>
    </Main>
  )
}

const NewsletterBody = styled.div`
  @media screen and (${ds.breakpoint.LAPTOP}) {
    max-width: 470px;
  }
`

export const Newsletter = styled.div`
  background-color: ${ds.color.SAND_2};
  border-radius: 12px;
  padding: 20px;
  margin: 25px 0 40px;
  position: relative;

  ${ds.styles.heading.Title3} {
    margin-bottom: 20px;
  }

  ${ds.styles.copy.Text1} {
    margin-top: 20px;
    opacity: 0.75;
  }

  ${NewsletterForm} {
    display: flex;
    flex-direction: column;

    ${ds.Input} {
      flex: 2;
      margin-bottom: 10px;
    }

    ${ds.Button} {
      flex: 1;
    }
  }

  ${ds.stickers.others.Newsletter} {
    position: absolute;
    bottom: 20px;
    right: 0;
    transform: translateY(100%);
    z-index: 2;

    @media screen and (${ds.breakpoint.MOBILE_S}) {
      width: 115px;
      height: 115px;
    }

    @media screen and (${ds.breakpoint.MOBILE_M}) {
      width: 125px;
      height: 125px;
    }

    @media screen and (${ds.breakpoint.MOBILE_L}) {
      width: 150px;
      height: 150px;
    }

    @media screen and (${ds.breakpoint.TABLET}) {
      width: 164px;
      height: 164px;
      bottom: unset;
      top: 20px;
      transform: translateY(-100%);
    }

    @media screen and (${ds.breakpoint.LAPTOP}) {
      transform: none;
      left: 600px;
      top: 58px;
    }
  }

  @media screen and (${ds.breakpoint.TABLET}) {
    ${NewsletterForm} {
      flex-direction: row;

      ${ds.Input} {
        margin-bottom: 0;
        margin-right: 10px;
      }
    }
  }

  @media screen and (${ds.breakpoint.LAPTOP}) {
    padding: 40px 420px 40px 77px;
    margin: 40px 0;
  }

  @media screen and (${ds.breakpoint.LAPTOP_L}) {
    padding-left: 77px;
    padding-right: 477px;
  }
`

export const PhoneSvg = styled.svg`
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
  pointer-events: none;
  width: 100%;
  height: 100%;
`

const IframeSizeLimiter = styled.div`
  max-width: 410px;
  margin: 0 auto;
`

export const Iframe = styled.iframe`
  width: 103%;
  height: 110%;
  transform: scale(0.8);
  transform-origin: 0 0;
  border: none;
  position: absolute;
  left: 9%;
  top: 8%;
`

export const FakeIframe = styled.div`
  width: 168%;
  height: 176%;
  transform: scale(0.5);
  transform-origin: 0 0;
  border: none;
  position: absolute;
  left: 8%;
  top: 8%;
  background-color: ${ds.color.SAND_1};

  ${ds.Loader} {
    width: 100px;
    height: 100px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`

export const IframeWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 200%;
  padding-bottom: 189%;

  @media screen and (${ds.breakpoint.LAPTOP}) {
    position: absolute;
    right: 20px;
    top: 130px;
    width: 360px;
    height: 682px;
    padding-bottom: 0;
  }

  @media screen and (${ds.breakpoint.LAPTOP_L}) {
    right: 77px;
  }
`

export const MainColumnMobile = styled.div`
  ${ds.styles.heading.Title1} {
    width: 85%;
    margin-bottom: 17px;
  }

  @media screen and (${ds.breakpoint.TABLET}) {
    display: none;
  }

  ${ds.styles.copy.Text1} {
    margin: 15px 0;
  }
`

export const MainColumn = styled.div`
  display: none;
  max-width: 820px;

  ${ds.styles.heading.Title2} {
    line-height: 88px;
    margin-bottom: 40px;
  }

  ${ds.styles.copy.Text5} {
    margin: 25px 0;
    max-width: 560px;
  }

  @media screen and (${ds.breakpoint.LAPTOP}) {
    margin-right: 400px;
  }

  @media screen and (${ds.breakpoint.TABLET}) {
    display: block;
  }
`

export const Main = styled.section`
  position: relative;
`

export const BaseBrush = styled.span`
  background-position: center 17px;
  background-repeat: no-repeat;
  background-size: 72% auto;
  display: inline-block;
  margin: -0.5em;
  padding: 0.5em;
  white-space: nowrap;

  @media screen and (${ds.breakpoint.TABLET}) {
    background-position: center 40px;
    background-size: 73% auto;
  }
`

const yellowBrushDataUrl = ds.utils.svg.toDataUrl(ds.brush.full.FullBrush2, {
  width: 268,
  height: 80,
  fill: ds.color.YELLOW,
})

const greenBrushDataUrl = ds.utils.svg.toDataUrl(ds.brush.full.FullBrush5, {
  width: 268,
  height: 80,
  fill: ds.color.LIGHT_GREEN,
})

export const Brush = styled(BaseBrush)<{ $color: 'yellow' | 'green' }>`
  ${({ $color }) => {
    if ($color === 'yellow') {
      return css`
        background-image: url('${yellowBrushDataUrl}');
      `
    }
    if ($color === 'green') {
      return css`
        background-image: url('${greenBrushDataUrl}');
      `
    }
  }}
`
